"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import AlertTriangle from "@crehana/compass.icons.fill/AlertTriangle";
import CheckmarkCircle from "@crehana/compass.icons.fill/CheckmarkCircle";
import CloseCircle from "@crehana/compass.icons.fill/CloseCircle";
import Info from "@crehana/compass.icons.fill/Info";
import CloseSmall from "@crehana/compass.icons.outline/CloseSmall";
import { cva } from "class-variance-authority";
import { toast } from "sonner";
import { cn } from "../utils.js";
const toastVariants = cva('', {
    variants: {
        variant: {
            info: 'tw-text-info-600 dark:tw-text-info-300 data-[border]:tw-bg-info-600 dark:data-[border]:tw-bg-info-300',
            success: 'tw-text-success-500 dark:tw-text-success-400 data-[border]:tw-bg-success-500 dark:data-[border]:tw-bg-success-400',
            warning: 'tw-text-on-hold-500 dark:tw-text-on-hold-300 data-[border]:tw-bg-on-hold-500 dark:data-[border]:tw-bg-on-hold-300',
            error: 'tw-text-alert-500 darkLtw-text-alert-300 data-[border]:tw-bg-alert-500 dark:data-[border]:tw-bg-alert-300'
        }
    },
    defaultVariants: {
        variant: 'success'
    }
});
const ToastContent = ({ id, title, variant, opts })=>{
    const showDescription = opts?.description || opts?.textLink;
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-w-full sm:tw-max-w-[380px] tw-min-w-[328px] tw-rounded tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-03 tw-shadow-03 dark:tw-shadow-none tw-h-full tw-overflow-hidden",
        children: [
            /*#__PURE__*/ jsx("div", {
                "data-border": true,
                className: cn('tw-w-0.4 tw-h-full tw-rounded-l tw-shrink-0 tw-absolute', toastVariants({
                    variant
                }))
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "tw-flex tw-px-1.6 tw-py-1.2 tw-w-full tw-gap-0.8",
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: "tw-shrink-0",
                        children: /*#__PURE__*/ jsx(ToastIcon, {
                            variant: variant,
                            size: 20,
                            className: toastVariants({
                                variant
                            })
                        })
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: "tw-space-y-0.4",
                        children: [
                            /*#__PURE__*/ jsx("h3", {
                                className: cn(toastVariants({
                                    variant
                                }), 'tw-font-subtitle5 dark:tw-text-neutral-light-100 tw-line-clamp-3', opts?.titleClassName),
                                children: title
                            }),
                            showDescription && /*#__PURE__*/ jsxs("p", {
                                className: "tw-font-body5 tw-line-clamp-3 tw-text-neutral-light-700 dark:tw-text-neutral-light-100",
                                children: [
                                    opts.description,
                                    opts.textLink && /*#__PURE__*/ jsx("span", {
                                        className: cn(toastVariants({
                                            variant
                                        }), 'tw-ml-0.4'),
                                        children: /*#__PURE__*/ jsx("a", {
                                            className: "tw-font-caption tw-underline",
                                            href: opts.textLink.url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: opts.textLink.text
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !opts?.hideCloseButton && /*#__PURE__*/ jsx("button", {
                        className: "tw-mb-auto tw-ml-auto",
                        type: "button",
                        onClick: ()=>toast.dismiss(id),
                        children: /*#__PURE__*/ jsx(CloseSmall, {
                            size: 20,
                            className: "tw-text-neutral-light-700 dark:tw-text-neutral-dark-500"
                        })
                    })
                ]
            })
        ]
    });
};
function ToastIcon({ variant, ...iconProps }) {
    if ('info' === variant) return /*#__PURE__*/ jsx(Info, {
        ...iconProps
    });
    if ('success' === variant) return /*#__PURE__*/ jsx(CheckmarkCircle, {
        ...iconProps
    });
    if ('warning' === variant) return /*#__PURE__*/ jsx(AlertTriangle, {
        ...iconProps
    });
    if ('error' === variant) return /*#__PURE__*/ jsx(CloseCircle, {
        ...iconProps
    });
    return null;
}
export { ToastContent };
